import { render, staticRenderFns } from "./SubElements.vue?vue&type=template&id=695c3520&scoped=true&"
import script from "./SubElements.vue?vue&type=script&lang=js&"
export * from "./SubElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695c3520",
  null
  
)

export default component.exports